import React from "react";
import { useHistory, useLocation } from "react-router-dom";

import { CategoriesHorizontal, CategoryItem, Image, WrapperImage, Title } from "./styles";

import handleURLParams from "../../../../utils/handleURLParams";
import CategoryPlaceholder from "../../../../assets/images/placeholders/categories-240x240.png";

export const Category = ({ title = "...", categoryImage, caregoriesBorderColor, className, category, params }) => {
    const history = useHistory();
    const location = useLocation();

    const handleRedirect = ({ category }) => {
        localStorage.setItem("categorizations", JSON.stringify([{ _id: category._id, nome: category.nome }]));

        handleURLParams({
            listOfKeyValues: [
                { key: 'categoryList', value: category._id },
                { key: 'limit', value: 8 }
            ],
            location: location,
            history: history
        });

        return history.push({ pathname: '/resultados', search: `${history.location.search}${params ? params : ''}` });
    }

    return (
        <CategoryItem className={className}>
            <a href='#!' onClick={(e) => handleRedirect({ category: category })}>
                <WrapperImage caregoriesBorderColor={caregoriesBorderColor}>
                    <Image onError={(e) => e.target.src = CategoryPlaceholder} src={categoryImage} />
                </WrapperImage>
                <Title> {title} </Title>
            </a>
        </CategoryItem>
    )
}

export const ScrollableCategories = ({ children }) => {

    return (
        <CategoriesHorizontal>
            {children}
        </CategoriesHorizontal>
    )
}

export default ScrollableCategories;